// useOrganizationChart.ts
import { useCallback, useState } from 'react';
import { useNodesState, useEdgesState, addEdge, Connection } from 'reactflow';
import { mobileNodes, initialNodes, initialEdges } from './ChartConfig';

export const useOrganizationChart = () => {
  // Check if mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  
  // State for profile sidebar
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);

  // ReactFlow states
  const [nodes, setNodes, onNodesChange] = useNodesState(isMobile ? mobileNodes : initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params: Connection) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );

  // Handle node click to open profile
  const onNodeClick = useCallback((event: React.MouseEvent, node: any) => {
    console.log('Node clicked:', node.id);
    setSelectedUser(node.id);
    setIsProfileOpen(true);
  }, []);

  // Close profile sidebar
  const closeProfile = () => {
    setIsProfileOpen(false);
    setSelectedUser(null);
  };

  const handleBackClick = () => {
    console.log('Back button clicked');
    // Add your navigation logic here
  };

  return {
    // States
    nodes,
    edges,
    isProfileOpen,
    selectedUser,
    isMobile,
    
    // Handlers
    onNodesChange,
    onEdgesChange,
    onConnect,
    onNodeClick,
    closeProfile,
    handleBackClick,
  };
};